import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useSessionErrors } from "./SessionErrorsHook";
// Set the default state values for each context
export const SessionErrorContext = /*#__PURE__*/createContext({});
export const SessionErrorContextProvider = ({
  children
}) => {
  const sessionErrors = useSessionErrors();
  const sessionErrorsContext = useMemo(() => ({
    ...sessionErrors
  }), [sessionErrors]);
  return /*#__PURE__*/React.createElement(SessionErrorContext.Provider, {
    value: sessionErrorsContext
  }, children);
};
export const useSessionErrorContext = () => {
  return useContext(SessionErrorContext);
};
SessionErrorContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};